<template>
    <div class="deliver-form">
        <app-filters
            :types="mailTypes"
            :searchMails="searchMails"
            :cancelFilter="cancelFilter"
            :venue-id="venueId"
        />
        <b-row class="mt-3 mb-2">
            <b-col cols="12" md="4">
                <b-button variant="outline-primary" size="sm" @click="exportMails" :disabled="!clientId && !client">
                    <i class="fa fa-download" aria-hidden="true"></i> Exportar
                </b-button>
            </b-col>
        </b-row>
        <div>
            <div class="alert alert-success" v-if="!theMails.length">
                ¡No hay datos!
            </div>
        </div>
        <app-delivered-mail-table
            :data="data"
            :view-mail="seeMore"
            :onChangePage="onChangePage"
            @sort="onSort"
        />

        <!-- Ver detalle de la correspondencia -->
        <app-pop-up id="view-email-more" title="Correspondencia">
            <div slot="body">
                <app-mail-card v-if="selectedMail" :mail="selectedMail" />
            </div>
        </app-pop-up>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

import vigilanceRepository from '../../../../../repositories/vigilance.repository'
import DeliveredMailFilters from './DeliveredMailFilters/DeliveredMailFilters.vue'
import DeliveredMailTable from './DeliveredMailTable/DeliveredMailTable.vue'
import MailCard from '../../MailCard/MailCard.vue'
export default {
    components: {
        appFilters: DeliveredMailFilters,
        appDeliveredMailTable: DeliveredMailTable,
        appMailCard: MailCard,
    },
    props: {
        clientId: {
            type: Number,
            default: 0,
        },
        venueId: {
            type: Number,
        },
    },
    data() {
        return {
            page: 1,
            selectedMail: '',
            theMails: [],
            data: {},
            filters: null,
            sort: {
                sortBy: 'created_at',
                sortDir: 'desc',
            },
        }
    },
    watch: {
        accessPoint(val) {
            if (!val) return

            this.loadMails()
        },
    },
    computed: {
        ...mapGetters(['mailTypes']),
    },
    methods: {
        ...mapActions(['saveMailDelivery']),
        seeMore(item) {
            this.selectedMail = Object.assign({}, item)
            this.$bus.$emit('view-email-more.open')
        },
        loadMails() {
            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
            }
            if (this.user.profile.slug === 'vigilante') {
                filters.venue = this.accessPoint.venue_id
            }
            const vr = Object.assign({}, vigilanceRepository)

            const clientId = !!this.clientId
                ? this.clientId
                : !!this.client
                ? this.client.id
                : 0

            if (!clientId) return

            vr.getDeliveredMailPaged(clientId, this.page, filters)
                .then(data => {
                    this.data = data
                    this.theMails = data.data
                })
                .catch(error =>
                    toastr.error(
                        'Ocurrió un error al cargar la correspondencias'
                    )
                )
        },
        searchMails(filters) {
            this.filters = filters
            this.page = 1
            this.loadMails()
        },
        cancelFilter() {
            this.page = 1
            this.$bus.$emit('delivered-mail-filters.clear')
            this.filters = null
            this.loadMails()
        },
        exportMails() {
            const clientId = this.clientId || (this.client && this.client.id) || 0
            if (!clientId) {
                toastr.error('No hay cliente seleccionado')
                return
            }
            const params = {
                client: clientId,
                delivered: '1',
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
            }
            if (this.venueId) params.venue = this.venueId
            else if (this.user && this.user.profile && this.user.profile.slug === 'vigilante' && this.accessPoint) params.venue = this.accessPoint.venue_id
            if (this.filters) {
                if (this.filters.type) params.type = this.filters.type
                if (this.filters.destination) params.destination = this.filters.destination
                if (this.filters.owner) params.owner = this.filters.owner
                if (this.filters.from) params.from = this.filters.from
                if (this.filters.to) params.to = this.filters.to
            }
            const queryString = Object.keys(params).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`).join('&')
            window.location.href = `exports/mail/export-excel?${queryString}`
        },
        onChangePage(page) {
            this.page = page
            this.loadMails()
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadMails()
        },
        clear() {
            this.data = {}
            this.theMails = []
        },
    },

    created() {
        this.loadMails()
        this.load('mailTypes')
        this.$bus.$on('delivered-mails.load', this.loadMails)
    },
}
</script>
